import settings from '@/settings'

export default {
  install(app) {
    const pixel = {
      isInited: false,
      payload: {},
      async init(pixelPayload) {
        if (!this.inited && settings.pixelUrl) {
          await this.loadScript()
          this.inited = true
        }
        if (pixelPayload) {
          this.setPayload(pixelPayload)
        }
      },
      setPayload(data) {
        if (!data) return

        this.payload = data
        if (window.__pi) {
          window.__pi.setPayload(data)
        }
      },
      loadScript() {
        return new Promise((resolve) => {
          const script = document.createElement('script')
          script.async = true
          script.src = settings.pixelUrl
          const firstScript = document.getElementsByTagName('script')[0]
          firstScript.parentNode.insertBefore(script, firstScript)
          script.onload = resolve
        })
      }
    }

    app.config.globalProperties.$pixel = pixel
    app.provide('pixel', pixel)
  }
}
